"use client";
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { spacing } from '../constants/spacing.js';
import { Gap } from '../Gap/Gap.web.js';
import { Checkbox } from '../Checkbox/Checkbox.web.js';
import { ContentText } from '../ContentText/ContentText.web.js';

var _excluded = ["color", "wrapperStyle", "disabled", "items", "checkboxButtonStyle", "onChange", "readOnly", "state", "size", "id", "label", "variant"];
var CheckboxGroup = function CheckboxGroup(_ref) {
  var color = _ref.color,
    wrapperStyle = _ref.wrapperStyle,
    disabled = _ref.disabled,
    items = _ref.items,
    checkboxButtonStyle = _ref.checkboxButtonStyle,
    onChange = _ref.onChange,
    readOnly = _ref.readOnly,
    state = _ref.state,
    _ref$size = _ref.size,
    size = _ref$size === undefined ? spacing.xxs : _ref$size,
    id = _ref.id,
    label = _ref.label,
    variant = _ref.variant,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Gap, _extends({
    "data-testid": "elemental-CheckboxGroup",
    style: wrapperStyle,
    size: size,
    flexDirection: "column",
    role: "group",
    "aria-labelledby": "elemental-CheckboxGroup-".concat(id || name, "__label")
  }, props), label && /*#__PURE__*/React.createElement(ContentText, {
    size: "l",
    weight: "medium",
    id: "elemental-CheckboxGroup-".concat(id || name, "__label")
  }, label), items.map(function (item) {
    return /*#__PURE__*/React.createElement(Checkbox, _extends({
      key: item.name,
      variant: variant,
      checked: state && state[item.name],
      disabled: disabled,
      onChange: onChange,
      style: checkboxButtonStyle,
      readOnly: readOnly,
      color: color
    }, item));
  }));
};

export { CheckboxGroup };
